import {useComponentProps} from 'helpers/hooks/utils';
import React from 'react';
import Box from 'components/atoms/Layout/Box/Box';
import StyledWelcomeBanner from 'components/organisms/Banners/WelcomeBanner/WelcomeBanner.styles';
import {H3, Span} from 'components/atoms/Text/Typography/Typography';
import Icon from 'components/atoms/Icons/Icon/Icon';
import constants from 'helpers/constants';
import Img from 'components/atoms/Images/Img/Img';

const WelcomeBanner = (props) => {
  const innerProps = useComponentProps(props, 'WelcomeBanner', {
    children: ['brand', 'background', 'slogan']
  });
  return <StyledWelcomeBanner {...innerProps}>
    <Box className={"WelcomeBanner-background"}>
      <H3 className={"WelcomeBanner-slogan"}>
        Find
        <Span> better</Span>
        <br/>companies,<br/>
        <Span>faster</Span>
      </H3>
    </Box>
    <Box className="WelcomeBanner-brand">
      {constants.basics.logo.full ?
        <Img src={constants.basics.logo.full} className="WelcomeBanner-brand-logo"/> :
        <React.Fragment>
          <Icon icon={constants.basics.logo.logo} className="WelcomeBanner-brand-logo"/>
          <Span className="WelcomeBanner-brand-logo-text">{constants.basics.shortName}</Span>
        </React.Fragment>
      }
    </Box>
  </StyledWelcomeBanner>
};

export default WelcomeBanner;
